<template>
  <div class="page-404">
    <i class="el-icon-warning page-404-icon"></i>
    <h2 class="page-404-title">您访问的页面不存在</h2>
  </div>
</template>

<script>
  export default {
    name: 'NotFound',
    props: {
      msg: String,
    },
  }
</script>
<style lang="scss" scoped>
  .page-404 {
    &-icon {
      display: block;
      width: 1em;
      margin: 50px auto 24px;
      color: $color-warning;
      font-size: 50px;
    }

    &-title {
      font-weight: 40;
      font-size: 20px;
      text-align: center;
    }
  }
</style>
